<div class="toggle-container">
    <div class="toggle-tab" [class.active]="viewMode === 'pres'" (click)="setView('pres')">
        Prescription
    </div>
    <div class="toggle-tab" [class.active]="viewMode === 'exec'" (click)="setView('exec')">
        Exécution
    </div>

</div>

<div class="content-container">
    <app-detail-prescription-hospit *ngIf="viewMode === 'pres'"></app-detail-prescription-hospit>
    <app-detail-prestation-hospit *ngIf="viewMode === 'exec'"></app-detail-prestation-hospit>
</div>